/** Industry benchmark data (synthetic) */
const INDUSTRY_BENCHMARKS = {
    alignmentScore: { avg: 65, best: 92 },
    travelReduction: { avg: 12, best: 35 },
    goldenZoneUtilization: { avg: 70, best: 95 },
    spaceUtilization: { avg: 75, best: 92 },
};
/**
 * Benchmark warehouse KPIs against industry standards.
 */
export function runBenchmark(ourMetrics) {
    const results = [];
    for (const [metric, benchmark] of Object.entries(INDUSTRY_BENCHMARKS)) {
        const ourValue = ourMetrics[metric] ?? 0;
        const { avg, best } = benchmark;
        // Calculate percentile (simplified linear interpolation)
        const range = best - avg;
        const ourOffset = ourValue - avg;
        let percentile = range !== 0 ? Math.min(100, Math.max(0, 50 + (ourOffset / range) * 50)) : 50;
        // For metrics where lower is better (cycle time)
        if (metric === 'orderCycleTime') {
            percentile = range !== 0 ? Math.min(100, Math.max(0, 50 + ((avg - ourValue) / range) * 50)) : 50;
        }
        const rating = percentile >= 90 ? 'excellent' :
            percentile >= 75 ? 'good' :
                percentile >= 50 ? 'average' :
                    percentile >= 25 ? 'below_average' : 'poor';
        results.push({
            metric,
            ourValue: Math.round(ourValue * 10) / 10,
            industryAverage: avg,
            bestInClass: best,
            percentileRank: Math.round(percentile),
            rating,
        });
    }
    return results;
}
//# sourceMappingURL=benchmarkEngine.js.map